import { useCallback, useEffect, useState } from "react";

// Loads a background-calculated result and polls while it is still running.
export function usePolled(fetcher) {
  const [r, setR] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback((retry) => fetcher(retry).then(x => { setR(x); setErr(null); }).catch(e => setErr(e.message)), [fetcher]);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    if (r?.state !== "running") return undefined;
    const t = setTimeout(() => load(), 2500);
    return () => clearTimeout(t);
  }, [r, load]);
  return [r, err, load];
}
